import React from "react";
import { outerLink } from "../../utils/functions";
import { Link } from "react-router-dom";

const Features = () => {
  return (
    <>
      <div className="features__box">
        <div className="container">
          <div className="left flex-start reveal-from-left">
            <img
              src={require("../../assets/images/feature-3.svg")}
              alt="feat-1"
            />
          </div>
          <div className="right">
            <div className="features__tag text__tag reveal-from-right">
              Data Warehouse & Data Transformation
            </div>
            <div className="features__heading text__heading reveal-from-right">
              Transform, define & combine
            </div>
            <div
              className="features__sub text__sub reveal-from-right"
              data-reveal-delay="200"
            >
              Clean, organise & enrich your data into easy to understand schemas
              and tables. Now data can be joined together to answer simple to
              complex business questions.
            </div>
            <div
              className="features__powered reveal-from-right"
              data-reveal-delay="400"
            >
              {/* powered by:{" "}
              <img src={require("../../assets/images/dbt.svg")} alt="dbt" />
              <img
                src={require("../../assets/images/clickhouse.svg")}
                alt="clickhouse"
              /> */}
            </div>
            <button
              className="button__main button__primary reveal-from-right"
              data-reveal-delay="400"
              onClick={() =>
                outerLink(
                  "https://docs.datazip.io/s/home/doc/2-transformation-Jt2OdqBGXQ"
                )
              }
            >
              Read More{" "}
              <img
                src={require("../../assets/images/long-arrow-right.svg")}
                alt="arrow right"
              />
            </button>
          </div>
        </div>
      </div>
      <div className="features__box">
        <div className="container">
          <div className="right">
            <div className="features__tag text__tag">Business intelligence</div>
            <div className="features__heading text__heading">
              Uncover insights
            </div>
            <div className="features__sub text__sub">
              Visualise data with tables & graphs with a portfolio of dashboards
              and reports.
            </div>
            <div className="divider features__divider" />
            <div className="features__content">
              <div className="item reveal-from-left" data-reveal-delay="100">
                <img
                  src={require("../../assets/images/check.svg")}
                  alt="check"
                />
                100+ charts to visualize and analyze your data easily
              </div>
              <div className="item reveal-from-left" data-reveal-delay="200">
                <img
                  src={require("../../assets/images/check.svg")}
                  alt="check"
                />
                Code-free visualization builder to extract and present data
              </div>
              <div className="item reveal-from-left" data-reveal-delay="300">
                <img
                  src={require("../../assets/images/check.svg")}
                  alt="check"
                />
                Scheduled Slack or email reports and alerts for your metrics
              </div>
              <div className="item reveal-from-left" data-reveal-delay="300">
                <img
                  src={require("../../assets/images/check.svg")}
                  alt="check"
                />
                Easily integrate and embed analytics directly inside your
                product
              </div>
            </div>
            <Link to="/onestack-data/business-intelligence">
              <button
                className="button__main button__primary reveal-from-right"
                data-reveal-delay="400"
              >
                Read More{" "}
                <img
                  src={require("../../assets/images/long-arrow-right.svg")}
                  alt="arrow right"
                />
              </button>
            </Link>
          </div>
          <div className="left reveal-from-right">
            <img
              src={require("../../assets/images/feature-4.svg")}
              alt="feat-1"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Features;
